module.exports = __webpack_public_path__ + "static/media/poolsky.ec887198.jpg";